import {React, useEffect, useState}  from 'react';
import { FaShoppingCart, FaStoreAltSlash } from "react-icons/fa";
import { Link } from 'react-router-dom';
import  './Customcss/home.css';
import axios from 'axios';
import CustomerChart from './Charts/CustomerChart';
import ProductChart from './Charts/ProductChart';
import MonthlyChart from './Charts/MonthlyChart';
import WeeklyChart from './Charts/WeeklyChart';
import { Row } from 'react-bootstrap';
import BallTriangle from 'react-loading-icons/dist/esm/components/ball-triangle';
import { useStateContext } from './Context/ContextProvider';
import CustomerTable from './Dashboard Items/CustomerTable';

function Dashboard() {
  const [Stores, setStores] = useState([]);
  const [topCustomers, settopCustomers] = useState([]);
  const [monthwise, setmonthwise] = useState([]);
  const [productsdata, setproductsdata] = useState([]);
  const [weeklysale, setweeklysale] = useState([]);
  const [dailyExpense, setDailyExpense] = useState('0');
  const [monthlyExpense, setMonthlyExpense] = useState('0');
  const [dailyWasooli, setDailyWasooli] = useState('0');
  const [monthlyWasooli, setMonthlyWasooli] = useState('0');
  const [dailyUdhar, setDailyUdhar] = useState('0');
  const [monthlyUdhar, setMonthlyUdhar] = useState('0');
  const [Loading, setLoading] = useState(true);
  const { type } = useStateContext();
  const [inactiveCustomers, setInactiveCustomers] = useState([]);
  const [defaulters, setDefaulters] = useState([]);

  useEffect(() => {
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.get('/api/home').then(res => {
        setStores(res.data.stores);
        setmonthwise(res.data.monthwise);
        settopCustomers(res.data.customerwise);
        setproductsdata(res.data.productsdata);
        setweeklysale(res.data.weeklysale);
        setMonthlyExpense(res.data.monthlyTotalExpense);
        setDailyExpense(res.data.dailyExpense);
        setDailyWasooli(res.data.dailyTotalWasooli);
        setMonthlyWasooli(res.data.monthlyTotalWasooli);
        setDailyUdhar(res.data.dailyUdhar);
        setMonthlyUdhar(res.data.monthlyUdhar);
        setInactiveCustomers(res.data.inactiveCustomers);
        setDefaulters(res.data.defaulters);
        setLoading(false);
      });
    });
  }, []);

  if (type === 'Salesman') {
    return (
      <div className='categories row animated fadeInDown'>
        <style>{`
          .store-grid {
            padding: 15px;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            min-height: 100vh;
          }
          .store-card {
            background: white;
            border-radius: 15px;
            padding: 20px 12px;
            margin: 8px;
            box-shadow: 0 8px 30px rgba(0,0,0,0.08);
            transition: all 0.3s ease;
            cursor: pointer;
            border: 2px solid transparent;
          }
          .store-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 40px rgba(0,0,0,0.15);
            border-color: #ff6b6b;
          }
          .store-icon {
            font-size: 40px;
            color: #ff6b6b;
            margin-bottom: 10px;
            display: inline-block;
            animation: pulse 2s infinite;
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          .store-name {
            color: #2d3436;
            font-weight: 700;
            font-size: 14px;
            margin-top: 8px;
            padding: 6px 12px;
            background: linear-gradient(135deg, #ff6b6b, #ee5a24);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          .store-link {
            text-decoration: none;
          }
          
          /* Mobile Responsive */
          @media (max-width: 768px) {
            .store-grid {
              padding: 10px;
            }
            .store-card {
              padding: 15px 10px;
              margin: 6px;
            }
            .store-icon {
              font-size: 32px;
            }
            .store-name {
              font-size: 12px;
            }
          }
          
          @media (max-width: 480px) {
            .store-grid {
              padding: 5px;
            }
            .store-card {
              padding: 12px 8px;
              margin: 4px;
              border-radius: 12px;
            }
            .store-icon {
              font-size: 28px;
            }
            .store-name {
              font-size: 11px;
            }
          }
        `}</style>
        <div className="store-grid row">
          {Stores.length === 0 ? (
            <center style={{ color: '#2d3436', fontSize: '18px', marginTop: '50px' }}>
              <div className="spinner-border text-danger" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3" style={{ fontSize: '14px' }}>Loading Stores...</p>
            </center>
          ) : (
            Stores && Stores.map((item, index) => (
              <div className='boxes col-6 col-md-4 col-lg-3 animated fadeInDown' key={item.id}>
                <Link to={`/productdetail/${item.id}`} className="store-link">
                  <div className="store-card text-center">
                    <div className="store-icon">
                      <FaStoreAltSlash />
                    </div>
                    <hr style={{ margin: '8px 0', borderTop: '2px solid #ff6b6b' }} />
                    <div className="store-name">
                      {item.name.length > 12 ? item.name.slice(0, 12) + '...' : item.name}
                    </div>
                    <small style={{ color: '#636e72', fontSize: '10px' }}>Click to view</small>
                  </div>
                </Link>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        /* Base Styles */
        .dashboard-container {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          min-height: 100vh;
          padding: 15px;
        }
        .dashboard-content {
          background: rgba(255,255,255,0.95);
          border-radius: 20px;
          padding: 20px;
          box-shadow: 0 15px 50px rgba(0,0,0,0.2);
          backdrop-filter: blur(10px);
        }
        
        /* Store Grid */
        .store-grid-modern {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          gap: 10px;
          margin-bottom: 25px;
        }
        .store-item-modern {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 12px 8px;
          border-radius: 12px;
          text-align: center;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }
        .store-item-modern:active {
          transform: scale(0.95);
        }
        .store-link-modern {
          color: white !important;
          text-decoration: none !important;
          font-weight: 600;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          flex-wrap: wrap;
        }
        .store-link-modern svg {
          font-size: 16px;
        }
        
        /* Stats Cards */
        .stats-card {
          border-radius: 15px;
          padding: 15px;
          color: white;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          margin-bottom: 10px;
        }
        .stats-card::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 100%;
          height: 100%;
          background: rgba(255,255,255,0.1);
          transform: rotate(45deg);
          transition: all 0.5s ease;
        }
        .stats-card:active::before {
          transform: rotate(0deg) scale(1.5);
        }
        .stats-card:active {
          transform: scale(0.98);
        }
        .stats-card-wasooli {
          background: linear-gradient(135deg, #00b894, #00a86b);
          box-shadow: 0 6px 20px rgba(0, 184, 148, 0.3);
        }
        .stats-card-udhar {
          background: linear-gradient(135deg, #6c5ce7, #a29bfe);
          box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
        }
        .stats-card-expense {
          background: linear-gradient(135deg, #fd79a8, #e17055);
          box-shadow: 0 6px 20px rgba(225, 112, 85, 0.3);
        }
        .stats-label {
          font-size: 13px;
          opacity: 0.9;
          font-weight: 300;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        .stats-value {
          font-size: 24px;
          font-weight: 700;
          margin-top: 3px;
          word-break: break-all;
        }
        .stats-divider {
          border-top: 2px solid rgba(255,255,255,0.3);
          margin: 10px 0;
        }
        
        /* Enhanced Loading Animation with Blur */
        .loading-wrapper {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(102, 126, 234, 0.7);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          flex-direction: column;
          animation: fadeInBlur 0.5s ease-in-out;
        }
        
        @keyframes fadeInBlur {
          from {
            opacity: 0;
            backdrop-filter: blur(0px);
            -webkit-backdrop-filter: blur(0px);
          }
          to {
            opacity: 1;
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
          }
        }
        
        .loading-content {
          text-align: center;
          padding: 40px;
          background: rgba(255,255,255,0.15);
          backdrop-filter: blur(30px);
          -webkit-backdrop-filter: blur(30px);
          border-radius: 30px;
          border: 1px solid rgba(255,255,255,0.3);
          box-shadow: 0 30px 80px rgba(0,0,0,0.3);
          animation: floatAnimation 3s ease-in-out infinite;
        }
        
        @keyframes floatAnimation {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        
        .loading-spinner-container {
          position: relative;
          width: 120px;
          height: 120px;
          margin: 0 auto 25px;
        }
        
        .loading-spinner {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
        }
        
        .loading-ring {
          position: absolute;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 4px solid transparent;
          border-top: 4px solid #ffffff;
          border-right: 4px solid rgba(255,255,255,0.3);
          animation: spin 1.2s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
        }
        
        .loading-ring:nth-child(2) {
          width: 100px;
          height: 100px;
          top: 10px;
          left: 10px;
          border-top: 4px solid rgba(255,255,255,0.6);
          border-left: 4px solid rgba(255,255,255,0.2);
          animation-duration: 1.5s;
          animation-direction: reverse;
        }
        
        .loading-ring:nth-child(3) {
          width: 80px;
          height: 80px;
          top: 20px;
          left: 20px;
          border-bottom: 4px solid rgba(255,255,255,0.8);
          border-right: 4px solid rgba(255,255,255,0.2);
          animation-duration: 1s;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .loading-title {
          color: white;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 10px;
          background: linear-gradient(135deg, #fff, #f0f0f0);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .loading-subtitle {
          color: rgba(255,255,255,0.9);
          font-size: 16px;
          font-weight: 300;
          letter-spacing: 2px;
          text-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }
        
        .loading-dots {
          display: inline-block;
          animation: dotPulse 1.4s infinite;
        }
        
        .loading-dots span {
          display: inline-block;
          animation: dotBounce 1.4s infinite;
          margin: 0 3px;
          font-size: 20px;
          color: rgba(255,255,255,0.9);
        }
        
        .loading-dots span:nth-child(2) {
          animation-delay: 0.2s;
        }
        
        .loading-dots span:nth-child(3) {
          animation-delay: 0.4s;
        }
        
        @keyframes dotBounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        
        .loading-progress {
          width: 200px;
          height: 3px;
          background: rgba(255,255,255,0.2);
          border-radius: 10px;
          margin: 20px auto 0;
          overflow: hidden;
          position: relative;
        }
        
        .loading-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #fff, #f0f0f0);
          border-radius: 10px;
          animation: progressAnimation 2s ease-in-out infinite;
          width: 0%;
        }
        
        @keyframes progressAnimation {
          0% { width: 0%; }
          50% { width: 70%; }
          100% { width: 100%; }
        }
        
        /* Charts */
        .chart-container {
          background: white;
          border-radius: 15px;
          padding: 15px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.06);
          margin-bottom: 15px;
          transition: all 0.3s ease;
          min-height: 250px;
        }
        .chart-container:active {
          transform: scale(0.99);
        }
        
        /* Mobile First Responsive */
        @media (max-width: 1200px) {
          .dashboard-container {
            padding: 12px;
          }
          .dashboard-content {
            padding: 15px;
            border-radius: 18px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 8px;
          }
          .store-item-modern {
            padding: 10px 6px;
          }
          .store-link-modern {
            font-size: 11px;
          }
          .stats-value {
            font-size: 22px;
          }
        }
        
        @media (max-width: 992px) {
          .dashboard-container {
            padding: 10px;
          }
          .dashboard-content {
            padding: 12px;
            border-radius: 15px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
            gap: 6px;
          }
          .store-item-modern {
            padding: 8px 5px;
            border-radius: 10px;
          }
          .store-link-modern {
            font-size: 10px;
            flex-direction: column;
            gap: 3px;
          }
          .store-link-modern svg {
            font-size: 14px;
          }
          .stats-card {
            padding: 12px;
            border-radius: 12px;
          }
          .stats-label {
            font-size: 12px;
          }
          .stats-value {
            font-size: 20px;
          }
          .chart-container {
            padding: 12px;
            min-height: 200px;
          }
          .loading-content {
            padding: 30px;
            margin: 20px;
          }
          .loading-title {
            font-size: 24px;
          }
        }
        
        @media (max-width: 768px) {
          .dashboard-container {
            padding: 8px;
          }
          .dashboard-content {
            padding: 10px;
            border-radius: 12px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(3, 1fr);
            gap: 5px;
          }
          .store-item-modern {
            padding: 8px 4px;
            border-radius: 8px;
          }
          .store-link-modern {
            font-size: 9px;
            flex-direction: column;
            gap: 2px;
          }
          .store-link-modern svg {
            font-size: 12px;
          }
          .stats-card {
            padding: 10px;
            border-radius: 10px;
            margin-bottom: 8px;
          }
          .stats-label {
            font-size: 11px;
            gap: 4px;
          }
          .stats-value {
            font-size: 18px;
          }
          .stats-divider {
            margin: 8px 0;
          }
          .chart-container {
            padding: 10px;
            border-radius: 10px;
            min-height: 180px;
            margin-bottom: 10px;
          }
          .row.g-3 {
            --bs-gutter-y: 0.5rem;
          }
          .loading-spinner-container {
            width: 90px;
            height: 90px;
          }
          .loading-spinner {
            width: 60px;
            height: 60px;
          }
          .loading-ring {
            width: 90px;
            height: 90px;
          }
          .loading-ring:nth-child(2) {
            width: 75px;
            height: 75px;
            top: 7.5px;
            left: 7.5px;
          }
          .loading-ring:nth-child(3) {
            width: 60px;
            height: 60px;
            top: 15px;
            left: 15px;
          }
          .loading-title {
            font-size: 20px;
          }
          .loading-subtitle {
            font-size: 14px;
          }
        }
        
        @media (max-width: 576px) {
          .dashboard-container {
            padding: 5px;
          }
          .dashboard-content {
            padding: 8px;
            border-radius: 10px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(2, 1fr);
            gap: 4px;
            margin-bottom: 15px;
          }
          .store-item-modern {
            padding: 6px 3px;
            border-radius: 6px;
          }
          .store-link-modern {
            font-size: 8px;
            flex-direction: column;
            gap: 2px;
          }
          .store-link-modern span {
            font-size: 8px;
          }
          .store-link-modern svg {
            font-size: 10px;
          }
          .stats-card {
            padding: 8px;
            border-radius: 8px;
            margin-bottom: 6px;
          }
          .stats-label {
            font-size: 10px;
            gap: 3px;
          }
          .stats-value {
            font-size: 16px;
          }
          .stats-divider {
            margin: 6px 0;
          }
          .chart-container {
            padding: 8px;
            border-radius: 8px;
            min-height: 150px;
            margin-bottom: 8px;
          }
          .row.g-3 {
            --bs-gutter-y: 0.3rem;
          }
          .col-md-4, .col-md-6 {
            padding-left: 4px;
            padding-right: 4px;
          }
          .loading-content {
            padding: 20px;
            margin: 15px;
          }
          .loading-wrapper {
            backdrop-filter: blur(15px);
            -webkit-backdrop-filter: blur(15px);
          }
          .loading-spinner-container {
            width: 70px;
            height: 70px;
          }
          .loading-spinner {
            width: 50px;
            height: 50px;
          }
          .loading-ring {
            width: 70px;
            height: 70px;
            border-width: 3px;
          }
          .loading-ring:nth-child(2) {
            width: 58px;
            height: 58px;
            top: 6px;
            left: 6px;
            border-width: 3px;
          }
          .loading-ring:nth-child(3) {
            width: 46px;
            height: 46px;
            top: 12px;
            left: 12px;
            border-width: 3px;
          }
          .loading-title {
            font-size: 18px;
          }
          .loading-subtitle {
            font-size: 12px;
          }
          .loading-progress {
            width: 150px;
          }
        }
        
        @media (max-width: 400px) {
          .dashboard-container {
            padding: 3px;
          }
          .dashboard-content {
            padding: 5px;
            border-radius: 8px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(2, 1fr);
            gap: 3px;
            margin-bottom: 10px;
          }
          .store-item-modern {
            padding: 4px 2px;
            border-radius: 4px;
          }
          .store-link-modern {
            font-size: 7px;
          }
          .store-link-modern svg {
            font-size: 8px;
          }
          .stats-value {
            font-size: 14px;
          }
          .stats-label {
            font-size: 9px;
          }
          .chart-container {
            min-height: 120px;
            padding: 5px;
          }
          .loading-wrapper {
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
          }
        }
        
        /* Touch-friendly improvements */
        @media (hover: none) {
          .store-item-modern:hover {
            transform: none;
          }
          .stats-card:hover {
            transform: none;
          }
          .chart-container:hover {
            transform: none;
          }
          .store-card:hover {
            transform: none;
          }
        }
        
        /* Landscape phones */
        @media (max-height: 500px) and (orientation: landscape) {
          .dashboard-container {
            padding: 5px;
          }
          .store-grid-modern {
            grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
            gap: 4px;
          }
          .stats-card {
            padding: 6px 10px;
          }
          .stats-value {
            font-size: 16px;
          }
          .stats-label {
            font-size: 10px;
          }
          .chart-container {
            min-height: 120px;
          }
          .loading-content {
            padding: 15px;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
          }
          .loading-spinner-container {
            width: 60px;
            height: 60px;
            margin: 0;
          }
          .loading-ring {
            width: 60px;
            height: 60px;
          }
          .loading-ring:nth-child(2) {
            width: 50px;
            height: 50px;
            top: 5px;
            left: 5px;
          }
          .loading-ring:nth-child(3) {
            width: 40px;
            height: 40px;
            top: 10px;
            left: 10px;
          }
          .loading-title {
            font-size: 16px;
          }
          .loading-subtitle {
            font-size: 11px;
          }
          .loading-wrapper {
            backdrop-filter: blur(15px);
            -webkit-backdrop-filter: blur(15px);
          }
        }
        
        /* Accessibility - Reduced Motion */
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
          .loading-wrapper {
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
          }
        }
      `}</style>

      <div className="dashboard-container">
        <div className="dashboard-content fadeInDown animated">
          {/* Store Grid */}
          <div className="store-grid-modern">
            {Stores.map(store => (
              <div className="store-item-modern" key={store.id}>
                <Link to={`/saleentry/${store.id}`} className="store-link-modern">
                  <FaShoppingCart />
                  <span>{store.name}</span>
                </Link>
              </div>
            ))}
          </div>

          {Loading ? (
            <div className="loading-wrapper">
              <div className="loading-content">
                <div className="loading-spinner-container">
                  <div className="loading-ring"></div>
                  <div className="loading-ring"></div>
                  <div className="loading-ring"></div>
                  <div className="loading-spinner">
                    <BallTriangle stroke='#ffffff' />
                  </div>
                </div>
                <div className="loading-title">
                  Loading Dashboard
                </div>
                <div className="loading-subtitle">
                  Please wait while we fetch your data
                  <span className="loading-dots">
                    <span>.</span>
                    <span>.</span>
                    <span>.</span>
                  </span>
                </div>
                <div className="loading-progress">
                  <div className="loading-progress-bar"></div>
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Stats Cards - Mobile Optimized */}
              <Row className="g-2 g-md-3 mb-3 mb-md-4">
                <div className="col-12 col-md-4">
                  <div className="stats-card stats-card-wasooli">
                    <div className="stats-label">
                      <i className="fas fa-hand-holding-usd"></i> آج کی وصولی
                    </div>
                    <div className="stats-value">Rs {dailyWasooli}</div>
                    <div className="stats-divider"></div>
                    <div className="stats-label">
                      <i className="fas fa-calendar-alt"></i> ماہانہ وصولی
                    </div>
                    <div className="stats-value" style={{ fontSize: 'clamp(14px, 3vw, 22px)' }}>Rs {monthlyWasooli}</div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="stats-card stats-card-udhar">
                    <div className="stats-label">
                      <i className="fas fa-hand-holding-heart"></i> آج کی واجب الادا
                    </div>
                    <div className="stats-value">Rs {dailyUdhar}</div>
                    <div className="stats-divider"></div>
                    <div className="stats-label">
                      <i className="fas fa-calendar-alt"></i> ماہانہ واجب الادا
                    </div>
                    <div className="stats-value" style={{ fontSize: 'clamp(14px, 3vw, 22px)' }}>Rs {monthlyUdhar}</div>
                  </div>
                </div>

                <div className="col-12 col-md-4">
                  <div className="stats-card stats-card-expense">
                    <div className="stats-label">
                      <i className="fas fa-wallet"></i> آج کا خرچہ
                    </div>
                    <div className="stats-value">Rs {dailyExpense}</div>
                    <div className="stats-divider"></div>
                    <div className="stats-label">
                      <i className="fas fa-calendar-alt"></i> ماہانہ اخراجات
                    </div>
                    <div className="stats-value" style={{ fontSize: 'clamp(14px, 3vw, 22px)' }}>Rs {monthlyExpense}</div>
                  </div>
                </div>
              </Row>

              {/* Customer Tables - Mobile Optimized */}
              <Row className="g-2 g-md-3 mb-3 mb-md-4">
                <div className="col-12 col-md-6">
                  <CustomerTable 
                    customers={inactiveCustomers} 
                    type={1} 
                    heading='وہ صارفین جنہوں نے 90 دنوں سے آرڈر نہیں کیا۔'
                  />
                </div>
                <div className="col-12 col-md-6">
                  <CustomerTable 
                    customers={defaulters} 
                    type={2} 
                    heading='تاخیر سے ادائیگی کرنے والے گاہک (30 دن سے زیادہ)'
                  />
                </div>
              </Row>

              {/* Charts - Mobile Optimized */}
              {type !== 'Salesman' && (
                <>
                  <Row className="g-2 g-md-3 mb-3 mb-md-4">
                    <div className="col-12 col-md-6">
                      <div className="chart-container">
                        <WeeklyChart datas={weeklysale} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="chart-container">
                        <CustomerChart datas={topCustomers} />
                      </div>
                    </div>
                  </Row>

                  <Row className="g-2 g-md-3">
                    <div className="col-12 col-md-6">
                      <div className="chart-container">
                        <MonthlyChart data={monthwise} />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="chart-container">
                        <ProductChart data={productsdata} />
                      </div>
                    </div>
                  </Row>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Dashboard;